import { ReactNode } from "react";
import { Box } from "@mui/material";

interface Props {
  sidebar: ReactNode;
  /** Barra superior que reemplaza al sidebar debajo de `md` (ver `NavbarTofuMobile`). */
  mobileNavbar: ReactNode;
  children: ReactNode;
  maxContentWidth?: number;
  /**
   * Ancho de la columna de contenido dentro del área disponible. El `70%` del wizard
   * angosto deja aire a los formularios; las pantallas anchas (`content-wide` del diseño)
   * la piden completa para que quepan las tres tarjetas por fila.
   */
  contentWidth?: string;
}

export const OnboardingWizardLayout = ({
  sidebar,
  mobileNavbar,
  children,
  maxContentWidth = 700,
  contentWidth = "70%",
}: Props) => (
  // `minWidth: 0` en cada nivel: sin él, un hijo con texto que no se parte (botones `nowrap`, montos)
  // ensancha el layout más allá de la pantalla y en móvil empuja el navbar fuera de la vista.
  <Box sx={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, minWidth: 0, width: "100%" }}>
    {mobileNavbar}
    <Box sx={{ display: "flex", flex: 1, minHeight: 0, minWidth: 0 }}>
      <Box sx={{ display: "flex", flexDirection: "column", flexShrink: 0 }}>{sidebar}</Box>
      <Box sx={{ flex: 1, minWidth: 0, overflowY: "auto", bgcolor: "#F6F8FB", p: { xs: 2, sm: 3, md: 5 } }}>
        <Box sx={{ maxWidth: maxContentWidth, mx: "auto", width: { xs: "100%", md: contentWidth } }}>{children}</Box>
      </Box>
    </Box>
  </Box>
);
